// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__bVrw5","additionalInfo":"AgreementModal_additionalInfo__3ErAR"};